'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' });

var Pause = function Pause(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Pause = (0, _pure2.default)(Pause);
Pause.muiName = 'SvgIcon';

exports.default = Pause;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Pause.js
// module id = 2673
// module chunks = 0